import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBento: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBento"><Path d="M11 21H3V13H11V21Z" fill="currentColor"/><Path d="M21 21H13V3H21V21Z" fill="currentColor"/><Path d="M11 11H3V3H11V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBento;
